<div class="container-fluid px-0">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="rectangle">
        <div class="col-12 px-0 d-flex title-div">
          <label class="title">Eklemek İstediğiniz Kart Tipini Seçin</label>
        </div>
        <div class="row card-row mr-0 ml-0">
          <div class="d-flex box" *ngFor="let card of cards" (click)="routingCreateCard(card.id)">
            <div class="information">
              <div>
                <label class="card-title">{{card.title}}</label>
              </div>
              <div>
                <label class="card-description">{{card.description}}</label>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <img class="card-image" [src]="card.imageUrl" alt="logo"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
